<script>
export default {
  name: "testDialog",
  props: {
    title: {
      type: String,
      default: "",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "create",
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      show: false,
      loading: false,
      treeCategory: [],
      form: {
        id: "",
        category: [],
        categoryName: [],
        name: "",
        time: "",
        startDate: "",
        endDate: "",
      },
      rules: {
        category: [
          { required: true, message: "请选择分类", trigger: "change" },
        ],
        name: [
          { required: true, message: "请输入测试名", trigger: "blur" },
          {
            min: 1,
            max: 200,
            message: "长度在 1 到 200 个字符",
            trigger: "blur",
          },
        ],
        time: [{ required: true, message: "请输入测试时长", trigger: "blur" }],
        startDate: [
          { required: true, message: "请输入测试开始时间", trigger: "change" },
        ],
        endDate: [
          { required: true, message: "请输入测试结束时间", trigger: "change" },
        ],
      },
    };
  },
  watch: {
    visible(val) {
      this.show = val;
      if (this.type === "create") {
        this.form.id = "";
        this.form.category = [];
        this.form.categoryName = [];
        this.form.name = "";
        this.form.time = "";
        this.form.startDate = "";
        this.form.endDate = "";
      }
      if (this.$refs.form) {
        this.$refs.form.clearValidate();
      }
      if (this.type === "edit" || this.type === "view") {
        this.form.id = this.data.id;
        this.form.category = this.data.category;
        this.form.categoryName = this.data.categoryName;
        this.form.name = this.data.name;
        this.form.time = this.data.time;
        this.form.startDate = this.data.startDate;
        this.form.endDate = this.data.endDate;
      }
    },
  },
  mounted() {
    this.show = this.visible;
    this.loadCategory();
  },
  methods: {
    loadCategory() {
      this.$cloud.get("/category/index").then((data) => {
        this.treeCategory = data;
      });
    },
    handleChangeCategory() {
      if (this.$refs["refSubCat"].getCheckedNodes()[0]) {
        this.form["categoryName"] =
          this.$refs["refSubCat"].getCheckedNodes()[0].pathLabels;
      }
    },
    handleClose() {
      console.log("关闭");
      this.$emit("update:visible", false);
    },
    closed() {
      this.form.id = "";
      this.form.category = [];
      this.form.categoryName = [];
      this.form.name = "";
      this.form.time = "";
      this.form.startDate = "";
      this.form.endDate = "";
      this.$refs.form.clearValidate();
    },
    handleSubmit() {
      console.log("数据", this.form);
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.loading = true;
          if (this.type === "create") {
            this.$cloud
              .post("examination/test/add", {
                name: this.form.name,
                category: this.form.category,
                categoryName: this.form.categoryName,
                time: this.form.time,
                startDate: this.form.startDate,
                endDate: this.form.endDate,
              })
              .then(() => {
                this.$message({
                  type: "success",
                  message: "添加成功",
                });
                this.handleClose();
                this.$emit("refresh");
              })
              .finally(() => {
                this.loading = false;
              });
          }
          if (this.type === "edit") {
            this.$cloud
              .post("examination/test/edit", {
                name: this.form.name,
                id: this.form.id,
                category: this.form.category,
                categoryName: this.form.categoryName,
                time: this.form.time,
                startDate: this.form.startDate,
                endDate: this.form.endDate,
              })
              .then(() => {
                this.$message({
                  type: "success",
                  message: "修改成功",
                });
                this.handleClose();
                this.$emit("refresh");
              })
              .finally(() => {
                this.loading = false;
              });
          }
        }
      });
    },
  },
};
</script>

<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="show"
      width="500px"
      @closed="closed"
      :before-close="handleClose"
    >
      <div class="p-6">
        <el-form
          :model="form"
          :rules="rules"
          ref="form"
          label-width="100px"
          class="p-6"
        >
          <el-form-item label="分类" prop="category" v-if="false">
            <el-cascader
              :disabled="type === 'view'"
              v-model="form.category"
              :props="{ checkStrictly: true }"
              ref="refSubCat"
              :options="treeCategory"
              @change="handleChangeCategory"
              :placeholder="
                form.categoryName.length > 0
                  ? form.categoryName.join('/')
                  : '请选择课程分类'
              "
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="测试名" prop="name">
            <el-input
              v-model="form.name"
              :disabled="type === 'view'"
              placeholder="请输入测试名字"
            ></el-input>
          </el-form-item>
          <el-form-item label="测试时长" prop="time">
            <el-input-number
              :step="10"
              :min="10"
              v-model="form.time"
              :disabled="type === 'view'"
              placeholder="请输入测试时长"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="开始时间" prop="startDate">
            <el-date-picker
              class="w-full"
              v-model="form.startDate"
              :disabled="type === 'view'"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择开始时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" prop="endDate">
            <el-date-picker
              class="w-full"
              v-model="form.endDate"
              :disabled="type === 'view'"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择结束时间"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="handleSubmit"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<style scoped>
.w-full {
  width: 100%;
}
</style>
